


import { Component, Vue } from "vue-property-decorator";
import { Login } from "@/shared/dtos/login";
import CardAuth from "@/views/login/card-auth.vue";
import LoginForm from "@/views/login/login-form.vue";

@Component({
  $_veeValidate: { validator: "new" },
  components: {
    CardAuth,
    LoginForm,
  },
})
export default class LoginFormulario extends Vue {

}
